import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lecture-material',
  templateUrl: './lecture-material.component.html',
  styleUrls: ['./lecture-material.component.css']
})
export class LectureMaterialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
